import React from "react";
import {Text} from '@fluentui/react';

const Header = () => {
  return (
      <div >
          <Text variant={'xLarge'} block>
            Create a new task.
          </Text>
      </div>
  );
};

export default Header;
